module.exports = __webpack_public_path__ + "biblio.png?a1d9b2635babc7d1f7468e69b5bb4771";


//////////////////
// WEBPACK FOOTER
// ./src/assets/biblio.png
// module id = 52
// module chunks = 0